module.exports = __webpack_public_path__ + "images/get-a-physical-copy-of-your-certificate-lms.jpg";